<div class="option-item-container">
  <terra-name-icon [icon]="icon"></terra-name-icon>
  <div class="text-container">
    <div class="text">
      {{ text | truncate: 38:true }}
    </div>
    <div class="sub-text">
      {{ subText }}
    </div>
  </div>
</div>
